@if (bootFailure.kind(); as failureKind) {
  <!-- Die Anmeldedaten fehlen: ohne sie ist nicht einmal entscheidbar, welche Seitenleiste gilt
       (Leistungserbringer oder externer Partner). Statt der Oberfläche steht deshalb ein
       vollwertiger Bildschirm da — mit Marke, benannter Ursache, Wiederholen und den beiden
       Auswegen, die hier noch funktionieren: Support und Abmelden. -->
  <div class="boot-screen">
    <div class="boot-logo" aria-label="SaniUp"></div>
    <lib-error-state variant="page" [kind]="failureKind" [retrying]="bootFailure.isRetrying()" (retry)="bootFailure.retry()">
      <button actions type="button" matButton (click)="logout()">Abmelden</button>
    </lib-error-state>
    <!--
      Die Kontaktwege stehen hier SICHTBAR und nicht hinter einem Knopf: Wer diesen Bildschirm
      sieht, kommt gerade nirgendwo hin, und ein `mailto:` ist genau dann der schlechteste Weg
      (ohne eingerichtetes Mailprogramm passiert schlicht nichts). Die Telefonnummer ist der
      einzige Weg, der in dieser Lage sicher trägt.
    -->
    <app-support-card
      class="boot-support"
      titel="Erreiche uns direkt"
      betreff="SaniUp ONE lädt nicht"
      text="Hallo SaniUp-Team,&#10;&#10;das Portal lädt bei uns gerade nicht.&#10;&#10;Viele Grüße"
    />
  </div>
} @else if (employeeService.currentlyLoggedInEmployee.isLoading()) {
  <div class="boot-screen">
    <div class="boot-logo" aria-label="SaniUp"></div>
    @defer (on timer(500ms)) {
      <mat-progress-bar class="boot-progress" mode="indeterminate"></mat-progress-bar>
    }
  </div>
} @else if (employeeService.hasRoleLeistungserbringer()) {
  @defer {
    <app-leistungserbringer-navigation></app-leistungserbringer-navigation>
  }
} @else if (employeeService.hasRoleExternalPartner()) {
  @defer {
    <app-external-partner-navigation></app-external-partner-navigation>
  }
} @else {
  <!-- Konto ohne Rolle: der Regelfall bei JEDER Erstanmeldung, weil das Backend den Mitarbeiter beim
       ersten Login selbst anlegt (`roles: []`) und erst ein Kollege die Rolle vergibt. Hier stand bis
       2026-08-18 ein Satz mit Logout-Knopf — richtig, aber eine Sackgasse. -->
  <app-zugang-ausstehend></app-zugang-ausstehend>
}
